import React, { useEffect } from 'react';
import { AnwThemeProvider } from '@audio-network/componentlibrary';
import PropTypes from 'prop-types';
import { sendAnalytics } from '@audio-network/analytics';
import * as Styled from './Player.styles';
import { NextSVG, PauseSVG, PlaySVG, PreviousSVG } from './assets';
import { TrackDetails, Volume, Waveform } from './components';
import { usePlayer, usePlayerAudio } from './hooks';
var Player = function Player(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    _ref$interfaceText = _ref.interfaceText,
    interfaceText = _ref$interfaceText === void 0 ? {} : _ref$interfaceText;
  var _usePlayer = usePlayer(),
    isPlaying = _usePlayer.isPlaying,
    currentTrack = _usePlayer.currentTrack,
    simpleTogglePlay = _usePlayer.simpleTogglePlay,
    playNextTrack = _usePlayer.playNextTrack,
    playPreviousTrack = _usePlayer.playPreviousTrack,
    queue = _usePlayer.queue;
  var _usePlayerAudio = usePlayerAudio(),
    skipBackwards = _usePlayerAudio.skipBackwards,
    skipForwards = _usePlayerAudio.skipForwards;
  var handlePlayClick = function handlePlayClick() {
    var _ref2, _currentTrack$album$n, _currentTrack$album, _currentTrack$album2, _currentTrack$album$c, _currentTrack$album3, _currentTrack$album3$, _currentTrack$album$g, _currentTrack$album4;
    sendAnalytics(null, 'Player', "Track ".concat(isPlaying ? 'Pause' : 'Play', " Clicked"), {
      TrackTitle: currentTrack.title,
      TrackId: currentTrack.id,
      AlbumNo: (_ref2 = (_currentTrack$album$n = (_currentTrack$album = currentTrack.album) === null || _currentTrack$album === void 0 ? void 0 : _currentTrack$album.number) !== null && _currentTrack$album$n !== void 0 ? _currentTrack$album$n : (_currentTrack$album2 = currentTrack.album) === null || _currentTrack$album2 === void 0 ? void 0 : _currentTrack$album2.id) !== null && _ref2 !== void 0 ? _ref2 : null,
      Catalogue: (_currentTrack$album$c = (_currentTrack$album3 = currentTrack.album) === null || _currentTrack$album3 === void 0 ? void 0 : (_currentTrack$album3$ = _currentTrack$album3.catalogue) === null || _currentTrack$album3$ === void 0 ? void 0 : _currentTrack$album3$.name) !== null && _currentTrack$album$c !== void 0 ? _currentTrack$album$c : null,
      Genre: (_currentTrack$album$g = (_currentTrack$album4 = currentTrack.album) === null || _currentTrack$album4 === void 0 ? void 0 : _currentTrack$album4.genre) !== null && _currentTrack$album$g !== void 0 ? _currentTrack$album$g : null
    });
    simpleTogglePlay();
  };
  var hasNativeBehaviour = function hasNativeBehaviour(key, role) {
    switch (role) {
      case 'checkbox':
      case 'combobox':
      case 'date':
      case 'email':
      case 'file':
      case 'input':
      case 'listbox':
      case 'number':
      case 'password':
      case 'radio':
      case 'searchbox':
      case 'tab':
      case 'tel':
      case 'text':
      case 'textarea':
      case 'textbox':
      case 'url':
        return key === 'Space' || key === 'ArrowUp' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowRight';
      case 'range':
      case 'slider':
        // https://www.w3.org/WAI/ARIA/apg/patterns/slider/
        return key === 'ArrowUp' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowRight';
      // eslint-disable-next-line prettier/prettier
      case 'button':
      default:
        return false;
    }
  };
  var currentTrackId = (currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.id) || null;
  var handleKeyboardControls = function handleKeyboardControls(e) {
    var _ref3, _target$getAttribute, _ref4, _currentTrack$album$n2, _currentTrack$album5, _currentTrack$album6, _currentTrack$album$c2, _currentTrack$album7, _currentTrack$album7$, _currentTrack$album$g2, _currentTrack$album8;
    var code = e.code,
      target = e.target,
      shiftKey = e.shiftKey;
    if (currentTrackId && !hasNativeBehaviour(code, (_ref3 = (_target$getAttribute = target.getAttribute('role')) !== null && _target$getAttribute !== void 0 ? _target$getAttribute : target.getAttribute('type')) !== null && _ref3 !== void 0 ? _ref3 : target.tagName.toLowerCase())) {
      switch (code) {
        case 'Space':
          e.preventDefault();
          sendAnalytics(null, 'Player', "Track ".concat(isPlaying ? 'Pause' : 'Play', " Clicked"), {
            TrackTitle: currentTrack.title,
            TrackId: currentTrack.id,
            AlbumNo: (_ref4 = (_currentTrack$album$n2 = (_currentTrack$album5 = currentTrack.album) === null || _currentTrack$album5 === void 0 ? void 0 : _currentTrack$album5.number) !== null && _currentTrack$album$n2 !== void 0 ? _currentTrack$album$n2 : (_currentTrack$album6 = currentTrack.album) === null || _currentTrack$album6 === void 0 ? void 0 : _currentTrack$album6.id) !== null && _ref4 !== void 0 ? _ref4 : null,
            KeyboardShortcut: 'True',
            Catalogue: (_currentTrack$album$c2 = (_currentTrack$album7 = currentTrack.album) === null || _currentTrack$album7 === void 0 ? void 0 : (_currentTrack$album7$ = _currentTrack$album7.catalogue) === null || _currentTrack$album7$ === void 0 ? void 0 : _currentTrack$album7$.name) !== null && _currentTrack$album$c2 !== void 0 ? _currentTrack$album$c2 : null,
            Genre: (_currentTrack$album$g2 = (_currentTrack$album8 = currentTrack.album) === null || _currentTrack$album8 === void 0 ? void 0 : _currentTrack$album8.genre) !== null && _currentTrack$album$g2 !== void 0 ? _currentTrack$album$g2 : null
          });
          simpleTogglePlay();
          break;
        case shiftKey && 'ArrowDown':
          playNextTrack();
          break;
        case shiftKey && 'ArrowUp':
          playPreviousTrack();
          break;
        case 'ArrowLeft':
          skipBackwards();
          sendAnalytics(null, 'Player', 'Track Skipped', {
            Direction: 'Backwards',
            KeyboardShortcut: 'True'
          });
          break;
        case 'ArrowRight':
          skipForwards();
          sendAnalytics(null, 'Player', 'Track Skipped', {
            Direction: 'Forwards',
            KeyboardShortcut: 'True'
          });
          break;
        default:
          break;
      }
    }
    return null;
  };
  var handlePlayNext = function handlePlayNext() {
    var _nextTrack$album, _nextTrack$album2;
    var currentPlayingTrackIndex = queue.findIndex(function (_ref5) {
      var id = _ref5.id;
      return id === currentTrackId;
    });
    var nextTrack = queue[currentPlayingTrackIndex + 1] || null;
    sendAnalytics(null, 'Player', 'Next Track Clicked', {
      TrackTitle: nextTrack === null || nextTrack === void 0 ? void 0 : nextTrack.title,
      TrackId: nextTrack === null || nextTrack === void 0 ? void 0 : nextTrack.id,
      AlbumNo: (nextTrack === null || nextTrack === void 0 ? void 0 : (_nextTrack$album = nextTrack.album) === null || _nextTrack$album === void 0 ? void 0 : _nextTrack$album.number) || (nextTrack === null || nextTrack === void 0 ? void 0 : (_nextTrack$album2 = nextTrack.album) === null || _nextTrack$album2 === void 0 ? void 0 : _nextTrack$album2.id)
    });
    playNextTrack();
  };
  var handlePlayPrevious = function handlePlayPrevious() {
    var _previousTrack$album, _previousTrack$album2;
    var currentPlayingTrackIndex = queue.findIndex(function (_ref6) {
      var id = _ref6.id;
      return id === currentTrackId;
    });
    var previousTrack = queue[currentPlayingTrackIndex - 1] || null;
    sendAnalytics(null, 'Player', 'Previous Track Clicked', {
      TrackTitle: previousTrack === null || previousTrack === void 0 ? void 0 : previousTrack.title,
      TrackId: previousTrack === null || previousTrack === void 0 ? void 0 : previousTrack.id,
      AlbumNo: (previousTrack === null || previousTrack === void 0 ? void 0 : (_previousTrack$album = previousTrack.album) === null || _previousTrack$album === void 0 ? void 0 : _previousTrack$album.number) || (previousTrack === null || previousTrack === void 0 ? void 0 : (_previousTrack$album2 = previousTrack.album) === null || _previousTrack$album2 === void 0 ? void 0 : _previousTrack$album2.id)
    });
    playPreviousTrack();
  };
  useEffect(function () {
    window.addEventListener('keyup', handleKeyboardControls);
    return function () {
      window.removeEventListener('keyup', handleKeyboardControls);
    };
  }, [isPlaying]);
  return /*#__PURE__*/React.createElement(AnwThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Styled.Wrapper, {
    "data-testid": "player",
    id: "player"
  }, /*#__PURE__*/React.createElement(TrackDetails, {
    currentTrack: currentTrack
  }), /*#__PURE__*/React.createElement(Styled.Controls, null, /*#__PURE__*/React.createElement(Styled.Button, {
    id: "player-previous-button",
    "data-testid": "player-previous-button",
    type: "button",
    onClick: handlePlayPrevious,
    disabled: !currentTrackId,
    "aria-label": interfaceText['player-previous']
  }, /*#__PURE__*/React.createElement(PreviousSVG, {
    disabled: !currentTrackId
  })), /*#__PURE__*/React.createElement(Styled.PlayButton, {
    id: "player-play-button",
    "data-testid": "player-play-button",
    type: "button",
    onClick: handlePlayClick,
    disabled: !currentTrackId,
    "data-isplaying": isPlaying ? 'true' : 'false',
    "aria-label": isPlaying ? interfaceText['player-pause'] : interfaceText['player-play']
  }, isPlaying ? /*#__PURE__*/React.createElement(PauseSVG, null) : /*#__PURE__*/React.createElement(PlaySVG, null)), /*#__PURE__*/React.createElement(Styled.Button, {
    id: "player-next-button",
    "data-testid": "player-next-button",
    type: "button",
    onClick: handlePlayNext,
    disabled: !currentTrackId,
    "aria-label": interfaceText['player-next']
  }, /*#__PURE__*/React.createElement(NextSVG, {
    disabled: !currentTrackId
  }))), /*#__PURE__*/React.createElement(Waveform, null), /*#__PURE__*/React.createElement(Styled.VolumeWrapper, null, /*#__PURE__*/React.createElement(Volume, {
    interfaceText: interfaceText
  }))));
};
Player.propTypes = {
  theme: PropTypes.string,
  interfaceText: PropTypes.objectOf(PropTypes.string)
};
Player.defaultProps = {
  theme: 'light',
  interfaceText: {}
};
export default Player;